var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',{attrs:{"z-index":"99999999"},model:{value:(_vm._internalValue),callback:function ($$v) {_vm._internalValue=$$v},expression:"_internalValue"}},[_c('v-progress-circular',{attrs:{"color":"white","size":"64","indeterminate":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }